import { render, staticRenderFns } from "./ListadoCausacion.vue?vue&type=template&id=251a984d"
import script from "./ListadoCausacion.vue?vue&type=script&lang=js"
export * from "./ListadoCausacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports